module.exports = __webpack_public_path__ + "media/images/area/area_yamaguchiM400-f55f13ce0522a9d68397444025c9064e.jpg";